export enum SubmissionStatus {
    Nova = 1,
    EmAnalise = 2,
    Pendente = 3,
    Cancelada = 4,
    Processada = 5,
}

export enum SubmissionType {
    Rotina = 1,
    Urgencia = 2,
}

export enum SubmissionFileType {
    Pdf = 1,
    Imagem = 2,
    Excel = 3,
    Word = 4,
}

export enum ExtractionStatus {
    Pendente = 1,
    Processando = 2,
    Concluida = 3,
    Erro = 4,
    NaoSuportado = 5,
}

export enum ContentOrigin {
    TextoNativo = 1,
    Ocr = 2,
}

type ChipColor = 'default' | 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error';

export const SUBMISSION_STATUS_LABEL: Record<SubmissionStatus, string> = {
    [SubmissionStatus.Nova]: 'Nova',
    [SubmissionStatus.EmAnalise]: 'Em análise',
    [SubmissionStatus.Pendente]: 'Pendente',
    [SubmissionStatus.Cancelada]: 'Cancelada',
    [SubmissionStatus.Processada]: 'Processada',
};

// Cor do chip e dos gráficos de cada status (mesma cor nas duas visões)
export const SUBMISSION_STATUS_COLOR: Record<SubmissionStatus, { chip: ChipColor; hex: string }> = {
    [SubmissionStatus.Nova]: { chip: 'info', hex: '#0288D1' },
    [SubmissionStatus.EmAnalise]: { chip: 'primary', hex: '#3949AB' },
    [SubmissionStatus.Pendente]: { chip: 'warning', hex: '#ED6C02' },
    [SubmissionStatus.Cancelada]: { chip: 'error', hex: '#D32F2F' },
    [SubmissionStatus.Processada]: { chip: 'success', hex: '#2E7D32' },
};

export const SUBMISSION_TYPE_LABEL: Record<SubmissionType, string> = {
    [SubmissionType.Rotina]: 'Rotina',
    [SubmissionType.Urgencia]: 'Urgência',
};

export const SUBMISSION_FILE_TYPE_LABEL: Record<SubmissionFileType, string> = {
    [SubmissionFileType.Pdf]: 'PDF',
    [SubmissionFileType.Imagem]: 'Imagem',
    [SubmissionFileType.Excel]: 'Excel',
    [SubmissionFileType.Word]: 'Word',
};

export const SUBMISSION_FILE_TYPE_COLOR: Record<SubmissionFileType, string> = {
    [SubmissionFileType.Pdf]: '#D32F2F',
    [SubmissionFileType.Imagem]: '#EF6C00',
    [SubmissionFileType.Excel]: '#2E7D32',
    [SubmissionFileType.Word]: '#1565C0',
};

export const EXTRACTION_STATUS_LABEL: Record<ExtractionStatus, string> = {
    [ExtractionStatus.Pendente]: 'Pendente',
    [ExtractionStatus.Processando]: 'Processando',
    [ExtractionStatus.Concluida]: 'Concluída',
    [ExtractionStatus.Erro]: 'Erro',
    [ExtractionStatus.NaoSuportado]: 'Não suportado',
};

export const EXTRACTION_STATUS_COLOR: Record<ExtractionStatus, { chip: ChipColor; hex: string }> = {
    [ExtractionStatus.Pendente]: { chip: 'default', hex: '#9E9E9E' },
    [ExtractionStatus.Processando]: { chip: 'info', hex: '#0288D1' },
    [ExtractionStatus.Concluida]: { chip: 'success', hex: '#2E7D32' },
    [ExtractionStatus.Erro]: { chip: 'error', hex: '#D32F2F' },
    [ExtractionStatus.NaoSuportado]: { chip: 'warning', hex: '#ED6C02' },
};

export const CONTENT_ORIGIN_LABEL: Record<ContentOrigin, string> = {
    [ContentOrigin.TextoNativo]: 'Texto nativo',
    [ContentOrigin.Ocr]: 'OCR',
};

// Dias de publicação dos veículos: 1 = domingo ... 7 = sábado (DATEPART(WEEKDAY) do backend)
export const WEEK_DAYS: { id: number; short: string; initial: string; name: string }[] = [
    { id: 1, short: 'dom.', initial: 'D', name: 'domingo' },
    { id: 2, short: 'seg.', initial: 'S', name: 'segunda-feira' },
    { id: 3, short: 'ter.', initial: 'T', name: 'terça-feira' },
    { id: 4, short: 'qua.', initial: 'Q', name: 'quarta-feira' },
    { id: 5, short: 'qui.', initial: 'Q', name: 'quinta-feira' },
    { id: 6, short: 'sex.', initial: 'S', name: 'sexta-feira' },
    { id: 7, short: 'sáb.', initial: 'S', name: 'sábado' },
];

// Espelha a seção "Submission" do appsettings do GovHub.Ser.Api (a API continua validando)
export const SUBMISSION_LIMITS = {
    maxFileSizeMb: 25,
    maxFilesPerSubmission: 20,
    maxSubmissionsPerBatch: 50,
    maxRequestSizeMb: 200,
    titleMaxLength: 500,
    cancelReasonMaxLength: 1000,
};

export const ACCEPTED_EXTENSIONS: Record<string, SubmissionFileType> = {
    pdf: SubmissionFileType.Pdf,
    jpg: SubmissionFileType.Imagem,
    jpeg: SubmissionFileType.Imagem,
    png: SubmissionFileType.Imagem,
    tif: SubmissionFileType.Imagem,
    tiff: SubmissionFileType.Imagem,
    xls: SubmissionFileType.Excel,
    xlsx: SubmissionFileType.Excel,
    doc: SubmissionFileType.Word,
    docx: SubmissionFileType.Word,
};

export const ACCEPT_ATTRIBUTE = Object.keys(ACCEPTED_EXTENSIONS).map((ext) => `.${ext}`).join(',');

export function getFileExtension(fileName: string): string {
    const dot = fileName.lastIndexOf('.');
    return dot < 0 ? '' : fileName.substring(dot + 1).toLowerCase();
}

// Tipo do arquivo pela extensão; undefined quando não é aceito
export function getFileTypeByName(fileName: string): SubmissionFileType | undefined {
    return ACCEPTED_EXTENSIONS[getFileExtension(fileName)];
}
